import React from "react";
import lodash from "lodash";
import { Box, Grid, Typography, IconButton } from "@material-ui/core";
import { firebaseUpdateUserNotification } from "../../firebase/user";
import {
  NotificationsOffRounded,
  NotificationsActiveRounded,
} from "@material-ui/icons";

import GaugeRadial from "../Gauge/radial_gauge";

export default function ModbusHandleBox(props) {
  /**
  |--------------------------------------------------
  | Handlers
  |--------------------------------------------------
  */
  function getRoundedSignalData() {
    const data = lodash.get(
      props.sensorDisplay,
      `modbus.${props.analogKey}`,
      `no information`
    );
    return typeof data !== "string" ? lodash.round(data, 2) : data;
  }

  /**
   * IS USER SUBSCRIBED
   */
  function isSub() {
    const channel = props.analogKey.replace("ch", "");

    const subChannel = lodash.get(
      props,
      `userProfile.notification.topic.${props.sensor.id}.ma.${channel}`,
      false
    );

    const subRegister = lodash.get(
      props,
      `userProfile.notification.topic.${props.sensor.id}.registering.${props.factoryID}_${props.sensor.id}_ma_${channel}.subscribe`,
      false
    );

    return subChannel && subRegister;
  }

  /**
   * SUBSCRIBE CHANNEL
   */
  async function handleSubScribe() {
    const channel = props.analogKey.replace("ch", "");
    let newNotification = lodash.cloneDeep(props.userProfile.notification);

    lodash.set(newNotification, `topic.${props.sensor.id}.ma.${channel}`, true);

    lodash.set(
      newNotification,
      `topic.${props.sensor.id}.registering.${props.factoryID}_${props.sensor.id}_ma_${channel}.subscribe`,
      true
    );

    firebaseUpdateUserNotification(props.user.uid, newNotification);
    props.onUpdateSub();
  }

  /**
   * UNSUBSCRIBE CHANNEL
   */
  async function handleUnSubScribe() {
    const channel = props.analogKey.replace("ch", "");
    let newNotification = lodash.cloneDeep(props.userProfile.notification);

    lodash.set(
      newNotification,
      `topic.${props.sensor.id}.ma.${channel}`,
      false
    );

    lodash.set(
      newNotification,
      `topic.${props.sensor.id}.registering.${props.factoryID}_${props.sensor.id}_ma_${channel}.subscribe`,
      false
    );

    firebaseUpdateUserNotification(props.user.uid, newNotification);
    props.onUpdateSub();
  }

  /**
  |--------------------------------------------------
  | Render
  |--------------------------------------------------
  */
  return (
    <Box
      bgcolor="#C4C4C4"
      mr={1}
      mb={1}
      pb={3}
      width={{ xs: "70vw", md: "97%" }}
      height="97%"
      borderRadius="6px"
    >
      <Grid container>
        <Grid item xs={12}>
          <div
            className="flex w-full flex-row justify-between items-center"
            style={{ color: "#303030" }}
          >
            <div className="text-xs ml-3">
              <Typography align="left">{props.item.name}</Typography>
            </div>
            <div className="">
              {isSub() ? (
                <IconButton
                  onClick={handleUnSubScribe}
                  style={{ color: "#303030" }}
                >
                  <NotificationsActiveRounded color="inherit" />
                </IconButton>
              ) : (
                <IconButton
                  onClick={handleSubScribe}
                  style={{ color: "#303030" }}
                >
                  <NotificationsOffRounded color="inherit" />
                </IconButton>
              )}
            </div>
          </div>
        </Grid>
        <Grid item xs={12}>
          <GaugeRadial item={props.item} value={getRoundedSignalData()} />
        </Grid>
      </Grid>
    </Box>
  );
}
